// Keeps recently played audio files in memory so replays and tab switches skip the network
const MAX_ENTRIES = 5;
const MAX_CACHEABLE_BYTES = 50 * 1024 * 1024;

const blobCache = new Map();
const inFlight = new Map();

// Re-inserting moves the url to the most-recently-used end of the Map
const touch = (url) => {
    const blob = blobCache.get(url);
    blobCache.delete(url);
    blobCache.set(url, blob);
    return blob;
};

const store = (url, blob) => {
    if (blob.size > MAX_CACHEABLE_BYTES) return;
    blobCache.set(url, blob);
    while (blobCache.size > MAX_ENTRIES) {
        blobCache.delete(blobCache.keys().next().value);
    }
};

// Returns the cached blob only if it is already downloaded
export const peekCachedAudio = (url) => (url && blobCache.has(url) ? touch(url) : null);

// Downloads the audio once per url; concurrent callers share the same request
export const getCachedAudio = async (url) => {
    if (!url) return null;

    const cached = peekCachedAudio(url);
    if (cached) return cached;

    if (inFlight.has(url)) return inFlight.get(url);

    const request = (async () => {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`audio fetch failed with ${response.status}`);
        const blob = await response.blob();
        store(url, blob);
        return blob;
    })();

    inFlight.set(url, request);
    try {
        return await request;
    } finally {
        inFlight.delete(url);
    }
};

export const clearAudioCache = () => {
    blobCache.clear();
    inFlight.clear();
};
